<template>
  <div style="height: 100%; background: #ffffff; border-top: 1px solid #eeeeee">
    <div class="tabs_box" style="height: 100%" v-loading="loading">
      <el-tabs v-model="activeName" style="height: 92%">
        <el-tab-pane label="基本" name="first">
          <basic ref="basic_component" :baseGoodsData="goodsData" @allSuccess="upSuccess" @isUp="haveUp">
          </basic>
        </el-tab-pane>
        <el-tab-pane label="规格" name="second">
          <spec :baseGoodsData="goodsData" :skusData="skusArr"></spec>
        </el-tab-pane>
      </el-tabs>
      <div class="basicStyle">
        <el-button v-if="activeName == 'first'" size="small" type="primary" @click="nextStep">下一步</el-button>
        <el-button v-if="activeName == 'second'" size="small" type="primary" @click="previousStep">上一步</el-button>
        <el-button v-if="activeName == 'second'" size="small" :disabled="saveDisable" type="primary" @click="save_goods">保存</el-button>
        <!-- <el-button v-if="activeName == 'second'" size="small" type="primary" @click="arraignGoods">提审</el-button> -->
        <el-button @click="go_back" size="small">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import basic from "./components/basic.vue";
import spec from "./components/spec.vue";
import {
  add_goods,
  goods_detail,
  get_goods_specs,
  getCustomSpecs,
  goods_edit,  //修改商品
  // get_base_goods,
  // get_basgoods,
} from "@/request/api/goods";
export default {
  components: {
    basic,
    spec,
  },
  data() {
    return {
      saveDisable:false,
      loading: false,
      isUpImage: false,
      goodsData: {
        goodsCode: "",
        baseCategoryName: '',
        skus: [],
        
        specPropList: [],
        skuPropList: [],
        paramsSpecsArr: [],//新增商品参数
        newSpecsArr: [],
        customSpecsList: [] //自定义规格列表
      },
      skusArr: [],
      activeName: "first",
      is_edit: false, //是否为编辑
    };
  },
  created() {
    this.getConcatArr()  //都要获取自定义属性
    if (this.$route.params.id != 0) {
      //编辑商品
      this.is_edit = true
      this.editShow()
    }
  },
  methods: {
    // // 提审
    // arraignGoods(){

    // },
    // 处理回显
    async editShow() {
      // 获取商品详情
      await goods_detail(this.$route.params.id).then((res) => {
        //商品详情
        console.log('商品详情', res.data)
        this.goodsData = Object.assign(this.goodsData, res.data)
        this.goodsData.specPropList = res.data.specPropsObj
        this.$refs.basic_component.wait_imgs = this.return_img_list(
          res.data.images
        );
        // skus的阶梯价格
        if (res.data.skus.length != 0) {
          res.data.skus.forEach(item => {
            item.pricePropList[0].priceType = 'add'
          })
          this.goodsData.skus = res.data.skus
          this.skusArr = res.data.skus
        }
        this.$forceUpdate()
      })
      // 获取商品规格和参数    系统的
      await get_goods_specs(this.goodsData.baseCategoryId).then(res => {
        // this.goodsData.specPropList = res.data.specPropList
        this.goodsData.skuPropList = res.data.skuPropList
      })
      // 处理商品参数----> 商品基本信息
      await this.transFormGoods()
      // 处理规格参数回显问题
      await this.goodsData.skuPropsObj.forEach(item => {
        this.goodsData.skuPropList.forEach(itemm => {
          if (itemm.id == item.id) {
            item = Object.assign(item, itemm)
          }
        })
      })

    },
    // 获取自定义的规格
    getConcatArr() {
      getCustomSpecs(1).then(res => {
        console.log(res)
        this.goodsData.customSpecsList = res.data
      })
    },
    // 处理商品参数
    transFormGoods() {
      for (var i = 0; i < this.goodsData.specPropList.length; i++) {
        this.goodsData.specPropsObj.forEach(item => {
          if (this.goodsData.specPropList[i].id == item.id) {
            this.$set(this.goodsData.specPropList[i], 'value', item.value)
            this.goodsData.specPropList[i] = Object.assign(this.goodsData.specPropList[i], item)
          }
        })
      }
    },
    upSuccess() {
      if (this.is_edit) { //修改
        if (!this.goodsData.images) {
          this.$api.e_msg('商品图片要选择')
          return
        }
        goods_edit(this.goodsData).then((res) => {
          this.loading = false
          this.saveDisable =false
          console.log('修改返回', res)
          if (res.code == 0) {
            this.$api.s_msg("保存成功待审核");
            this.$router.push({ path: "/menu/goods" });
          } else {
            this.$api.e_msg(res.msg);
          }
        })
      } else {  //添加商品
        if (!this.goodsData.images) {
          this.$api.e_msg('商品图片要选择')
          return
        }
        add_goods(this.goodsData).then((res) => {
          this.loading = false
          this.saveDisable =false
          console.log('新增返回', res);
          if (res.code == 0) {
            this.$api.s_msg("保存成功待审核");
            this.$router.push({ path: "/menu/goods" });
          } else {
            this.$api.e_msg(res.msg);
          }
        })
        // 处理新增参数
        console.log(this.goodsData)
      }
    },
    haveUp(e) {
      console.log('回来一下', e)
      this.isUpImage = e
    },
    save_goods() {
      // 判断新增商品图片未选择
      if(!this.isUpImage&&!this.is_edit){
        this.$api.e_msg('图片未选择')
        return
      }
      console.log(this.goodsData.freightType)
      console.log(this.$refs.basic_component.$refs.uploadImage.fileList)
      this.$nextTick(() => {
        console.log(this.$refs.basic_component.$refs.uploadImage.fileList)
      });
      if(this.goodsData.freightType==undefined){
        this.$api.e_msg('物流运费未选择')
        return
      }
      if (!this.goodsData.title) {
        this.$api.e_msg('商品名称为空')
        return
      }
      if (!this.goodsData.baseCategoryName) {
        this.$api.e_msg('商品分类未选择')
        return
      }
      this.loading = true
      this.saveDisable = true
      // 处理新增参数
      this.goodsData.specPropsObj = this.goodsData.specPropList.concat(this.goodsData.paramsSpecsArr)
      if (this.isUpImage) {
        console.log('要上传图片再说')
        this.$refs.basic_component.$refs.uploadImage.submit()
      } else {
        if (!this.is_edit) {
          console.log('新增漏掉了')
          this.$refs.basic_component.$refs.uploadImage.submit()
        } else {
          this.loading = false
          this.saveDisable = false
          // 修改中   图片移除完了要处理
          if (!this.goodsData.images) {
            this.$api.e_msg('商品图片为空')
            return
          }
          goods_edit(this.goodsData).then((res) => {
            this.loading = false
            this.saveDisable =false
            if (res.code == 0) {
              this.$api.s_msg("保存成功待审核");
              this.$router.push({ path: "/menu/goods" });
            } else {
              this.$api.e_msg(res.msg);
            }
          })
        }
      }
    },
    previousStep() {
      this.activeName = "first";
    },
    nextStep() {
      this.activeName = "second";
    },
    // 图片转换
    return_img_list(e) {
      if (e) {
        let arr = e.split(",");
        let arr_img = [];
        arr.forEach((item) => {
          let obj = {
            name: "",
            url: item,
          };
          arr_img.push(obj);
        });
        return arr_img;
      } else {
        return [];
      }
    },
    go_back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs__nav-wrap {
  padding: 0 30px;
}

/deep/ .el-tabs__header {
  margin: 0;
}

.tabs_box /deep/ .el-tabs__content {
  height: 93%;
  overflow: hidden;
  overflow-y: auto;
  padding-top: 10px;
  box-sizing: border-box;
}

.tabs_box /deep/ .el-tabs__nav-scroll {
  padding: 0 40px;
}

.basicStyle {
  width: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 8%;
  padding: 10px 0;

}
</style>